/* eslint-disable import/default */
import { type EmojiId } from '@app/client/common/structs/emoji/emoji';

import type emojiAdminWasm from '@tari-labs/emojis-wasm-admin';
import type emojiWasm from '@tari-labs/emojis-wasm-default';
import type emojiTypesWasm from '@tari-labs/emojis-wasm-types';

export const ACTION_SET_EMOJI_WASM = 'ACTION_SET_EMOJI_WASM';
export const ACTION_SET_EMOJI_ADMIN_WASM = 'ACTION_SET_EMOJI_ADMIN_WASM';
export const ACTION_SET_EMOJI_TYPES_WASM = 'ACTION_SET_EMOJI_TYPES_WASM';
export const ACTION_RESET_EMOJI_STORE = 'ACTION_RESET_EMOJJI_STORE';

export enum WasmType {
    EmojiWasm,
    EmojiAdminWasm,
    EmojiTypesWasm,
    All,
}

export type EmojiWasm = typeof emojiWasm;
export type EmojiAdminWasm = typeof emojiAdminWasm;
export type EmojiTypesWasm = typeof emojiTypesWasm;

export interface EmojiState {
    wasm: EmojiWasm | null;
    types: EmojiTypesWasm | null;
    adminWasm: EmojiAdminWasm | null;
    emojis: string[];
    userEmojis: EmojiId[];
}

interface SetEmojiWasmAction {
    type: typeof ACTION_SET_EMOJI_WASM;
    wasm: EmojiWasm;
}

interface SetEmojiAdminWasmAction {
    type: typeof ACTION_SET_EMOJI_ADMIN_WASM;
    wasm: EmojiAdminWasm;
}

interface SetEmojiTypesWasmAction {
    type: typeof ACTION_SET_EMOJI_TYPES_WASM;
    wasm: EmojiTypesWasm;
}
interface ResetEmojiStoreAction {
    type: typeof ACTION_RESET_EMOJI_STORE;
}

export type EmojiActionTypes =
    | SetEmojiWasmAction
    | SetEmojiTypesWasmAction
    | SetEmojiAdminWasmAction
    | ResetEmojiStoreAction;
